import React from 'react'
import { useParams } from 'react-router-dom'
import { Skeleton, Stack, Tooltip } from '@mui/material'
import { Row, LevelTag, levelLetter, CatTag, PlainCard, Base, OrgTagIcon, AppTagIcon } from './components'
import Text from '@/components/Text'
import { getNotAuthNotificationDetails } from '@/api'
import { useQuery } from '@tanstack/react-query'
import { leastText } from '@/constant'
import MarkDown from '@/components/MarkDown'

const MessagePage: React.FC<unknown> = () => {
  const { message_id } = useParams()

  const { data: detail, isLoading } = useQuery(
    ['getNoAuthNotifigationDetails', message_id],
    // @ts-ignore
    () => getNotAuthNotificationDetails(message_id),
    {
      enabled: !!message_id,
    },
  )

  return (
    <Base>
      <PlainCard>
        <Row
          sx={{
            marginBottom: '32px',
            width: '100%',
            justifyContent: 'space-between',
          }}
        >
          {isLoading ? (
            <Skeleton width={240} height={30} />
          ) : (
            <Text weight='bold' size='md' sx={{ display: 'flex', alignItems: 'center', gap: '24px' }}>
              {detail?.simple_text}
              {/*   @ts-ignore */}
              <LevelTag level={detail?.level}>
                {/*   @ts-ignore */}
                {levelLetter[detail?.level]}
              </LevelTag>
            </Text>
          )}
        </Row>
        <Stack sx={{ gap: '8px', flex: 1, height: '85%' }}>
          {isLoading ? (
            <Skeleton width={100} height={20} />
          ) : (
            <Text
              weight='regular'
              size='xs'
              sx={{
                color: leastText,
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                flexWrap: 'wrap',
              }}
            >
              {detail?.created_at} <span>|</span>
              {detail?.send_name && (
                <Tooltip followCursor={true} title={'产品应用'}>
                  <Text
                    weight='regular'
                    size='xs'
                    sx={{
                      color: leastText,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <AppTagIcon />
                    {detail?.send_name}
                  </Text>
                </Tooltip>
              )}
              {detail?.org_name && (
                <Tooltip followCursor={true} title={'空间'}>
                  <Text
                    weight='regular'
                    size='xs'
                    sx={{
                      color: leastText,
                      display: 'flex',
                      alignItems: 'center',
                      gap: '8px',
                    }}
                  >
                    <OrgTagIcon />
                    {detail?.org_name}
                  </Text>
                </Tooltip>
              )}
            </Text>
          )}
          {isLoading ? (
            <Row sx={{ gap: '8px' }}>
              <Skeleton width={62} height={24} />
              <Skeleton width={62} height={24} />
            </Row>
          ) : (
            <Row sx={{ gap: '8px', flexWrap: 'wrap' }}>
              {detail?.tags?.map((item) => (
                <CatTag key={item?.id}>{item.name}</CatTag>
              ))}
            </Row>
          )}
          {isLoading ? (
            <Skeleton variant='text' width={'100%'} height={100} />
          ) : (
            <MarkDown sx={{ flex: 1, marginTop: '24px' }} content={detail?.full_text} />
          )}
        </Stack>
      </PlainCard>
    </Base>
  )
}

export default MessagePage
